import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./MilestoneProgressbar.module.scss";

interface MilestoneProgressbarProps {
  milestones: number[];
  currentValue: number;
  maxValue: number;
}

export const MilestoneProgressbar: React.FC<MilestoneProgressbarProps> = ({
  milestones,
  currentValue,
  maxValue,
}) => {
  const progressPercent = Math.min(
    (currentValue / (maxValue + 300)) * 100,
    100
  );

  return (
    <Box
      className={styles.wrapper}
      data-testid={"milestone-progressbar-wrapper"}
    >
      {/* Progress bar container */}
      <Box className={styles.progressContainer}>
        {/* Filled progress */}
        <Box
          className={styles.progressFill}
          sx={{ width: `${progressPercent}%` }}
          data-testid="progress-fill"
        />

        {/* Milestone Dots */}
        {milestones.map((milestone, idx) => {
          const leftPercent = (milestone / (maxValue + 300)) * 100;
          const isReached = currentValue >= milestone;

          return (
            <Box
              key={idx}
              className={`${styles.dot} ${
                isReached ? styles.dotReached : styles.dotPending
              }`}
              sx={{ left: `${leftPercent}%` }}
              data-testid={!isReached ? "dot" : "dot-reached"}
            />
          );
        })}
      </Box>

      {/* Milestone Labels */}
      <Box className={styles.labelsWrapper}>
        {milestones.map((milestone, idx) => {
          const leftPercent = (milestone / (maxValue + 300)) * 100;
          return (
            <Typography
              key={idx}
              variant="body1"
              className={styles.label}
              sx={{ left: `${leftPercent}%` }}
            >
              {milestone}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
};
